import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  chChatHealthInformationCopilotQuery as chChatHealthInformationCopilotQueryType,
  chChatHealthInformationCopilotQuery$data,
} from "@/modules/chats/services/ai/ch/__generated__/chChatHealthInformationCopilotQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chChatHealthInformationCopilotQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    chatHealthInformationCopilot: ch_chatHealthInformationCopilot(aiRequestMetadata: $aiRequestMetadata) {
      healthInformation {
        allergies {
          diagnosis {
            diagnosisCode
            text
          }
          comment
        }
        conditions {
          diagnosisCode
          text
        }
        medications
      }
      result
    }
  }
`

export const chChatHealthInformationCopilotQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<chChatHealthInformationCopilotQueryType>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}

export type ChHealthInformationCopilot = NonNullable<
  chChatHealthInformationCopilotQuery$data["chatHealthInformationCopilot"]["healthInformation"]
>
